module.exports = __webpack_public_path__ + "static/media/eject.d8d58435.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/eject.svg
// module id = 22
// module chunks = 1